var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',[_c('router-link',{staticClass:"side-icon-button",attrs:{"id":"boardsroute","to":_vm.item.to}},[_c('base-icon-label',{staticClass:"overflow-string",attrs:{"iconSize":_vm.item.iconSize,"iconlabelafter":"text-light font-weight-bold","color":"light","icon":_vm.item.icon,"labelafter":_vm.item.name}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }